import { classnames } from '@aibees/shared/utils';
import { memo, useState } from 'react';
import { SubscriptionRow } from './components/subscription-row';
import * as Styled from './styles';
import * as SX from './sx';
import type { SubscriptionPlansProps as Props } from './types';
import { useSubscriptionEntitlements } from '../../hooks/use-subscription-entitlements';

export const SubscriptionPlans = memo(({ className }: Props) => {
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [expandedIcons, setExpandedIcons] = useState<{
    [key: number]: { [key: number]: boolean };
  }>({});
  const entitlements = useSubscriptionEntitlements();

  const handleToggleExpand = (key: string) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [key]: !prevExpandedRows[key],
    }));
  };

  const handleIconToggle = (rowIndex: number, groupIndex: number) => {
    setExpandedIcons((prevExpandedIcons) => ({
      ...prevExpandedIcons,
      [rowIndex]: {
        ...(prevExpandedIcons[rowIndex] || {}),
        [groupIndex]: !(prevExpandedIcons[rowIndex]?.[groupIndex] || false),
      },
    }));
  };

  return (
    <Styled.Wrapper
      className={classnames('SubscriptionPlans', className)}
      sx={SX.root}
    >
      {entitlements
        .find((e) => e.parent === 'no-parent')
        ?.groups.find((g) => g.group === 'no-group')
        ?.entitlements.map((item, index) => (
          <SubscriptionRow
            key={index}
            row={item}
            rowIndex={index}
            expanded={expandedRows[index]}
            onToggleExpand={handleToggleExpand}
            onToggleIcon={handleIconToggle}
            expandedIcons={expandedIcons}
          />
        ))}

      {entitlements
        .filter((e) => e.parent !== 'no-parent')
        .map((item, rowIndex) => (
          <SubscriptionRow
            key={item.parent}
            row={item}
            rowIndex={rowIndex}
            expanded={expandedRows[item.parent]}
            onToggleExpand={handleToggleExpand}
            onToggleIcon={handleIconToggle}
            expandedIcons={expandedIcons}
          />
        ))}
    </Styled.Wrapper>
  );
});

SubscriptionPlans.displayName = 'SubscriptionPlans';
